import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router';
import moment from 'moment';
import AlertItem from './AlertItem';
import OrderAlertTable from './OrderAlertTable';

const ProductLinesAlert = ({ alert, ...other }) => {
  const { value } = alert;
  const { product_lines: productLines } = value;
  const len = productLines.length;
  // Construct a pretty view of the product lines purchased: Heartgard, Nexgard, and Bravecto
  const productLinesDisplay = _.reduce(productLines, (res, p, idx) => {
    res.push(<strong className='u-colorBlue'>{p}</strong>);
    if (idx < len - 1 && len > 2) {
      res.push(', ');
    }
    if (idx === len - 2 && len > 1) {
      res.push(' and ');
    }
    return res;
  }, []);

  return (
    <AlertItem
      alert={alert}
      date={moment(alert.date).format('MMMM Do, YYYY')}
      icon='cubes'
      title={(
        <div>
          <Link to={`/corporate/analyze/buyer/${alert.buyer.id}`}>
            {alert.buyer.name}
          </Link>
          {' '} purchased {' '}
          {productLinesDisplay}
          {' '} in {moment(alert.date).format('MMMM')}
        </div>
      )}
      content={(
        <OrderAlertTable includeExport={true} orders={value.orders} type={value.type} />
      )}
      {...other}
    />
  );
};

ProductLinesAlert.propTypes = {
  alert: PropTypes.object.isRequired,
  onIsDeletedChange: PropTypes.func.isRequired,
  onIsFlaggedChange: PropTypes.func.isRequired
};

export default ProductLinesAlert;
